"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var HOUR = 60 * 60;
var DAY = HOUR * 24;
var FACTOR = 0.5;

var PremiumPriceOracle = /*#__PURE__*/function () {
  /**
   * expiryDate is auction start time
   * @param {*} expiryDate 
   * @param {*} algorithm 
   */
  function PremiumPriceOracle(expiryDate, algorithm) {
    (0, _classCallCheck2["default"])(this, PremiumPriceOracle);
    this.algorithm = algorithm;

    if (algorithm === 'exponential') {
      this.startingPremiumInUsd = 100000000;
      this.totalDays = 21;
      this.lastValue = this.startingPremiumInUsd * Math.pow(FACTOR, this.totalDays);
    } else {
      this.startingPremiumInUsd = 100000;
      this.totalDays = 28;
    }

    this.releasedDate = expiryDate.clone();
    this.zeroPremiumDate = this.releasedDate.clone().add(this.totalDays, 'days');
    this.diff = this.zeroPremiumDate.diff(this.releasedDate);
    this.rate = this.startingPremiumInUsd / this.diff;
    this.diffInHour = this.zeroPremiumDate.diff(this.releasedDate, 'hour');
    this.hourlyRate = this.startingPremiumInUsd / this.diffInHour;
  }

  (0, _createClass2["default"])(PremiumPriceOracle, [{
    key: "getDaysPast",
    value: function getDaysPast(currentDate) {
      return parseInt(currentDate.diff(this.releasedDate) / DAY / 1000);
    }
  }, {
    key: "getHoursPast",
    value: function getHoursPast(currentDate) {
      return parseInt(currentDate.diff(this.releasedDate) / HOUR / 1000);
    }
  }, {
    key: "getDaysRemaining",
    value: function getDaysRemaining(currentDate) {
      return this.totalDays - this.getDaysPast(currentDate);
    }
  }, {
    key: "getHoursRemaining",
    value: function getHoursRemaining(currentDate) {
      return this.totalDays * 24 - this.getHoursPast(currentDate);
    }
  }, {
    key: "getTargetDateByAmount",
    value: function getTargetDateByAmount(amount) {
      var amountFloat = parseFloat(amount);

      if (this.algorithm === 'exponential') {
        var daysPast;

        if (amount < this.lastValue) {
          daysPast = this.totalDays;
        } else {
          daysPast = Math.log((amountFloat + this.lastValue) / this.startingPremiumInUsd) / Math.log(FACTOR);
        }

        var r = this.releasedDate.clone().add(daysPast * 24 * 60, 'minutes');
        return r;
      } else {
        return this.zeroPremiumDate.clone().subtract(amountFloat / this.rate / 1000, 'second');
      }
    }
  }, {
    key: "getTargetAmountByDaysPast",
    value: function getTargetAmountByDaysPast(daysPast) {
      if (this.algorithm === 'exponential') {
        var premium = this.startingPremiumInUsd * Math.pow(FACTOR, daysPast);

        if (premium >= this.lastValue) {
          return premium - this.lastValue;
        } else {
          return 0;
        }
      } else {
        return (this.totalDays - daysPast) * (this.hourlyRate * 24);
      }
    }
  }, {
    key: "getAmountByDateRange",
    value: function getAmountByDateRange(startDate, currentDate) {
      var hoursPast = currentDate.diff(startDate) / HOUR / 1000;
      var daysPast = hoursPast / 24;
      return this.getTargetAmountByDaysPast(daysPast);
    }
  }]);
  return PremiumPriceOracle;
}();

exports["default"] = PremiumPriceOracle;